import React from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import { openContactModal } from '../../../redux/global/globalReducer';

import scss from './FailedMedia.module.scss';

function FailedMedia({ className }) {
  const { t } = useTranslation('studio');
  const dispatch = useDispatch();

  const handleOpenContactModal = () => {
    dispatch(openContactModal());
  };

  return (
    <div className={clsx(scss.wrapper, className)}>
      <Icon icon={ICONS.Logo} className={scss.icon} disableCommonColors />
      <span className={scss.label}>{t('errorLoading')}</span>
      <span className={scss.subLabel}>
        {t('errorLoadingDescription')}{' '}
        <button type='button' className={scss.contactLink} onClick={handleOpenContactModal}>
          {t('contactSupport')}
        </button>
      </span>
    </div>
  );
}

export default FailedMedia;
